module.exports = __webpack_public_path__ + "media/images/no_image_available-f7fffcc0e70d64aaec42396b6c347939.png";